import React, { useState, useCallback, useEffect } from "react";
import moment from "moment";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../../components/Breadcrumbs";
import ExportButton from "./DebtorReportComponents/ExportButton";
import DataTable from "./DebtorReportComponents/DataTable";
import DetailModal from "./DebtorReportComponents/DetailModal";
import useDebtorReport from "./DebtorReportComponents/useDebtorReport";
import {
  SUMMARY_FIELDS,
  DETAIL_FIELDS,
} from "./DebtorReportComponents/Fields";
import Navbar from "../../components/Modal/Navbar";
import Datetime from "react-datetime";
export default function DebtorReport() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [period, setPeriod] = useState("monthly");
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [sortField, setSortField] = useState("AR_Code");
  const [sortOrder, setSortOrder] = useState("asc");
  const [showDetail, setShowDetail] = useState(false);
  const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const today = moment();
    let start;
    switch (period) {
      case "daily":
        start = today.clone();
        break;
      case "yearly":
        start = today.clone().startOf("year");
        break;
      case "monthly":
      default:
        start = today.clone().startOf("month");
        break;
    }
    setStartDate(start.format("YYYY-MM-DD"));
    setEndDate(today.format("YYYY-MM-DD"));
    setPage(1);
  }, [period]);

  const {
    current,
    total,
    pages,
    sums,
    detailData,
    detailInfo,
    showDetailByIndex,
  } = useDebtorReport({
    startDate,
    endDate,
    search,
    sortField,
    sortOrder,
    page,
    perPage,
    statusFilter,

  });

  const handleSort = useCallback(
    (field) => {
      if (sortField === field) {
        setSortOrder((o) => (o === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
      setPage(1);
    },
    [sortField]
  );

  const handlePrevDetail = useCallback(
    () => showDetailByIndex(detailInfo.index - 1),
    [showDetailByIndex, detailInfo]
  );

  const handleNextDetail = useCallback(
    () => showDetailByIndex(detailInfo.index + 1),
    [showDetailByIndex, detailInfo]
  );

  return (
    <div className="bg-light min-vh-100 mx-3">
      <div className="wrapper">
        <Navbar />
        <main className="main-panel">
          <div className="container-fluid px-3 py-2">

            <div className="mb-2">
              <Breadcrumbs
                page="สรุปลูกหนี้ค้างชำระ"
                items={[
                  { name: "CRM", url: "/crm" },
                  { name: "สรุปลูกหนี้ค้างชำระ", url: "/debtor-report" },
                ]}
              />
            </div>

            <div className="mb-3">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-bottom py-2">
                  <div className="d-flex align-items-center justify-content-between">

                  </div>
                </div>

                <div className={`collapse ${!isFilterCollapsed ? "show" : ""}`}>
                  <div className="card-body py-3">
                    <div className="row gx-3 gy-2">

                      <div className="col-sm-6 col-md-2">
                        <label className="form-label small text-muted">สถานะ</label>
                        <select
                          className="form-select form-select-sm"
                          value={statusFilter}
                          onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}
                        >
                          <option value="">ทั้งหมด</option>
                          <option value="จ่ายครบ">จ่ายครบ</option>
                          <option value="ค้างจ่าย">ค้างจ่าย</option>
                        </select>
                      </div>

                      <div className="col-sm-6 col-md-3">
                        <label className="form-label small text-muted">ค้นหาลูกค้า</label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">
                            <i className="fas fa-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="รหัส/ชื่อลูกค้า..."
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                          />
                          {search && (
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => { setSearch(""); setPage(1); }}
                            >
                              <i className="fas fa-times" />
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-2">
                        <label className="form-label small text-muted">วันที่เริ่มต้น</label>
                        <Datetime
                          value={moment(startDate)}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          locale="th"
                          closeOnSelect
                          onChange={(date) => {
                            if (moment.isMoment(date)) {
                              setStartDate(date.format("YYYY-MM-DD"));
                              setPage(1);
                            }
                          }}
                          renderInput={(props, openCalendar) => (
                            <input
                              {...props}
                              onClick={openCalendar}
                              className="form-control form-control-sm"
                              value={moment(startDate).locale("th").add(543, "years").format("DD/MM/YYYY")}
                              readOnly
                              style={{ backgroundColor: "#fff" }}
                            />
                          )}
                        />
                      </div>

                      <div className="col-sm-6 col-md-2">
                        <label className="form-label small text-muted">วันที่สิ้นสุด</label>
                        <Datetime
                          value={moment(endDate)}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          locale="th"
                          closeOnSelect
                          onChange={(date) => {
                            if (moment.isMoment(date)) {
                              setEndDate(date.format("YYYY-MM-DD"));
                              setPage(1);
                            }
                          }}
                          renderInput={(props, openCalendar) => (
                            <input
                              {...props}
                              onClick={openCalendar}
                              className="form-control form-control-sm"
                              value={moment(endDate).locale("th").add(543, "years").format("DD/MM/YYYY")}
                              readOnly
                              style={{ backgroundColor: "#fff" }}
                            />
                          )}
                        />
                      </div>


                      <div className="col-12 col-md-2">
                        <label className="form-label small text-muted">ทางลัดวันที่</label>
                        <div className="d-flex flex-wrap gap-2">
                          <button
                            className="btn btn-outline-orange btn-sm"
                            onClick={() => {
                              const today = moment();
                              setStartDate(today.format("YYYY-MM-DD"));
                              setEndDate(today.format("YYYY-MM-DD"));
                              setPage(1);
                            }}
                          >วันนี้</button>
                          <button
                            className="btn btn-outline-orange btn-sm"
                            onClick={() => {
                              const m = moment().startOf("month");
                              setStartDate(m.format("YYYY-MM-DD"));
                              setEndDate(moment().format("YYYY-MM-DD"));
                              setPage(1);
                            }}
                          >เดือนนี้</button>
                          <button
                            className="btn btn-outline-orange btn-sm"
                            onClick={() => {
                              const y = moment().startOf("year");
                              setStartDate(y.format("YYYY-MM-DD"));
                              setEndDate(moment().format("YYYY-MM-DD"));
                              setPage(1);
                            }}
                          >ปีนี้</button>
                        </div>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-end">
                        <ExportButton
                          current={current}
                          startDate={startDate}
                          endDate={endDate}
                          sums={sums}
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="mb-3">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-bottom py-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="rounded-circle me-2" style={{ width: '3px', height: '18px', backgroundColor: '#ff9800' }} />
                      <h6 className="card-title mb-0 text-muted">สรุปลูกหนี้ค้างชำระ</h6>
                    </div>
                  </div>
                </div>



                <div className="card-body p-0">
                  <div className="table-responsive" style={{ maxHeight: '80vh' }}>
                    <DataTable
                      fields={SUMMARY_FIELDS}
                      data={current}
                      onSort={handleSort}
                      sortField={sortField}
                      sortOrder={sortOrder}
                      onRowClick={(i) => {
                        showDetailByIndex(i);
                        setShowDetail(true);
                      }}
                      sums={sums}
                    />
                  </div>

                  <div className="row  g-2 p-2 align-items-center">
                    <div className="col-6 d-flex align-items-center">
                      <label className="me-2">Items per page:</label>
                      <select
                        className="form-select w-auto"
                        value={perPage}
                        onChange={(e) => { setPerPage(+e.target.value); setPage(1); }}
                      >
                        {[50, 100, 150, total].map((n) => (
                          <option key={n} value={n}>{n === total ? "All" : n}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                      <ul className="pagination mb-0">
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setPage((p) => Math.max(p - 1, 1))}>Previous</button>
                        </li>
                        {[...Array(pages)].map((_, i) => (
                          <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
                            <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                          </li>
                        ))}
                        <li className={`page-item ${page === pages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setPage((p) => Math.min(p + 1, pages))}>Next</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <DetailModal
              open={showDetail}
              onClose={() => setShowDetail(false)}
              data={detailData}
              fields={DETAIL_FIELDS}
              info={detailInfo}
              onPrev={handlePrevDetail}
              onNext={handleNextDetail}
              totalSummary={current.length}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
